import { convertToObject } from '../../utils'
const initialState = {}
export const questionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INIT_QUESTIONS':
      if (!action.data) {
        return {}
      } else {
        return action.data
      }
    case 'ADD_QUESTION': {
      const id = action.data.id
      return {
        ...state,
        [id]: action.data,
      }
    }
    case 'UPDATE_QUESTION':
    case 'QUESTION_SCALE_UP':
    case 'QUESTION_SCALE_DOWN': {
      const key = action.data.id
      return {
        ...state,
        [key]: action.data,
      }
    }
    case 'UPDATE_QUESTIONS': {
      const questions = { ...state }
      if (questions && action.data) {
        const copyWithAddedTexts = Object.values(questions).concat(
          Object.values(action.data)
        )
        return convertToObject(copyWithAddedTexts)
      }
      return state
    }
    case 'DELETE_QUESTION': {
      const questions = { ...state }
      const filtered = Object.values(questions).filter((p) => p.id !== action.data)
      return convertToObject(filtered)
    }
    case 'DELETE_PAGE': {
      const copy2 = Object.values(state).filter(
        (question) => question.pageId !== action.data
      )
      return convertToObject(copy2)
    }
    case 'PURGE':
      return initialState
    default:
      return state
  }
}
